/* Jules Crystal Design: mobile gallery navigation and variant stock notices. */
(() => {
  const mobileView = () => window.matchMedia('(max-width: 749px)').matches;

  function initProductSection(stockScript) {
    if (stockScript.dataset.julesInitialized === 'true') return;
    const sectionId = stockScript.id.replace('JulesStock-', '');
    const section = document.getElementById('shopify-section-' + sectionId);
    if (!section) return;
    stockScript.dataset.julesInitialized = 'true';

    let stockEntries = [];
    try { stockEntries = JSON.parse(stockScript.textContent); } catch (_) { stockEntries = []; }
    const stocks = new Map(stockEntries.map(item => [String(item.id), item]));
    const picker = section.querySelector('variant-radios, variant-selects');
    const variantDataScript = picker && picker.querySelector('script[type="application/json"]');
    let variants = [];
    try { variants = JSON.parse(variantDataScript ? variantDataScript.textContent : '[]'); }
    catch (_) { variants = []; }
    const stockNotice = document.getElementById('JulesLowStock-' + sectionId);

    function optionSelections() {
      if (!picker) return [];
      if (picker.tagName.toLowerCase() === 'variant-radios') {
        return Array.from(picker.querySelectorAll('fieldset')).map(fieldset => {
          const radio = fieldset.querySelector('input[type="radio"]:checked');
          return radio ? radio.value : '';
        });
      }
      return Array.from(picker.querySelectorAll('select')).map(select => select.value);
    }

    function refreshInventory() {
      const choices = optionSelections();
      let selected = variants.find(v => v.options && v.options.every((option, i) => option === choices[i]));
      if (!picker) selected = { id: stockScript.dataset.selected };
      const record = selected ? stocks.get(String(selected.id)) : null;
      const quantity = record ? Number(record.quantity) : NaN;
      const showLowStock = !!record && record.available && record.tracked &&
        record.policy !== 'continue' && Number.isFinite(quantity) && quantity >= 1 && quantity < 3;
      if (stockNotice) {
        stockNotice.hidden = !showLowStock;
        stockNotice.textContent = showLowStock ? 'Only ' + quantity + ' left' : '';
      }

      if (!picker || !variants.length) return;
      if (picker.tagName.toLowerCase() === 'variant-radios') {
        Array.from(picker.querySelectorAll('fieldset')).forEach((fieldset, optionIndex) => {
          fieldset.querySelectorAll('input[type="radio"]').forEach(input => {
            const available = variants.some(v => v.available && v.options &&
              v.options.every((option, i) => option === (i === optionIndex ? input.value : choices[i])));
            input.dataset.julesSoldOut = available ? 'false' : 'true';
            const label = document.querySelector('label[for="' + input.id + '"]');
            if (label) label.title = available ? '' : 'Sold out';
          });
        });
      } else {
        Array.from(picker.querySelectorAll('select')).forEach((select, optionIndex) => {
          Array.from(select.options).forEach(option => {
            const available = variants.some(v => v.available && v.options &&
              v.options.every((entry, i) => entry === (i === optionIndex ? option.value : choices[i])));
            const original = option.dataset.julesOriginalLabel || option.textContent.trim().replace(/\s+\u2014\s+Sold out$/, '');
            option.dataset.julesOriginalLabel = original;
            option.dataset.julesSoldOut = available ? 'false' : 'true';
            option.textContent = available ? original : original + ' — Sold out';
          });
        });
      }
    }
    refreshInventory();
    if (picker) picker.addEventListener('change', () => {
      refreshInventory();

    });

    const component = section.querySelector('.product__media-wrapper slider-component.jules-gallery');
    const gallery = component && component.querySelector('.jules-gallery__stage');
    if (!gallery) return;
    const thumbs = Array.from(component.querySelectorAll('[data-jules-thumb]'));
    const position = component.querySelector('[data-jules-gallery-position]');
    const previous = component.querySelector('[data-jules-inline-prev]');
    const next = component.querySelector('[data-jules-inline-next]');
    const slides = () => Array.from(gallery.querySelectorAll(':scope > li.product__media-item'))
      .filter(item => !item.classList.contains('product__media-item--variant') || item === gallery.firstElementChild);
    let currentId = null;
    function selectPhoto(id) {
      const items = slides();
      if (!items.length) return;
      const selected = items.find(item => item.dataset.mediaId === id) || items[0];
      currentId = selected.dataset.mediaId;
      Array.from(gallery.querySelectorAll(':scope > li.product__media-item')).forEach(item => {
        const active = item === selected;
        item.classList.toggle('jules-is-active', active);
        item.setAttribute('aria-hidden', String(!active));
        item.inert = !active;
      });
      const index = items.indexOf(selected);
      const image = selected.querySelector('img');
      if (image) image.loading = 'eager';
      thumbs.forEach(button => {
        const selectedThumb = button.dataset.julesThumb === currentId;
        button.classList.toggle('is-current', selectedThumb);
        button.setAttribute('aria-pressed', String(selectedThumb));
      });
      if (position) position.textContent = (index + 1) + ' / ' + items.length;
      gallery.dataset.julesReady = 'true';
    }
    const move = direction => {
      const items = slides();
      const index = items.findIndex(item => item.dataset.mediaId === currentId);
      if (items.length) selectPhoto(items[((index < 0 ? 0 : index) + direction + items.length) % items.length].dataset.mediaId);
    };
    thumbs.forEach(button => button.addEventListener('click', () => selectPhoto(button.dataset.julesThumb)));
    [[previous,-1],[next,1]].forEach(([button,direction]) => {
      if (!button) return;
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        move(direction);
      },true);
    });
    let startX=0,startY=0;
    gallery.addEventListener('touchstart', event => {
      if (!mobileView()) return;
      const touch=event.changedTouches[0];if(!touch)return;
      startX=touch.clientX;startY=touch.clientY;
    },{passive:true});
    gallery.addEventListener('touchend', event => {
      if(!mobileView())return;
      const touch=event.changedTouches[0];if(!touch)return;
      const dx=touch.clientX-startX,dy=touch.clientY-startY;
      if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.3)move(dx<0?1:-1);
    },{passive:true});
    const observer=new MutationObserver(() => {
      const first=slides()[0];
      if(first&&first.dataset.mediaId!==currentId)selectPhoto(first.dataset.mediaId);
    });
    observer.observe(gallery,{childList:true});
    const first=slides()[0];if(first)selectPhoto(first.dataset.mediaId);

  }
  function initialize() {
    document.querySelectorAll('script[id^="JulesStock-"]').forEach(initProductSection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
